'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Img = require('../../01.atoms/Img/Img.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-stage',
    cnRow = "".concat(CLASSNAME, "__row"),
    cnCol = "".concat(CLASSNAME, "__col"),
    cnImage = "".concat(CLASSNAME, "__image"),
    cnContent = "".concat(CLASSNAME, "__content"),
    cnFooter = "".concat(CLASSNAME, "__footer"),
    cnDate = "".concat(CLASSNAME, "__date"),
    cnReadingTime = "".concat(CLASSNAME, "__reading-time"),
    cnIcon = "".concat(CLASSNAME, "__icon");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function Stage(_ref) {
  var alt = _ref.alt,
      body = _ref.body,
      className = _ref.className,
      date = _ref.date,
      headline = _ref.headline,
      readingTime = _ref.readingTime,
      srcset = _ref.srcset,
      timeUnit = _ref.timeUnit,
      twoColumns = _ref.twoColumns;

  var Wrapper = function Wrapper(_ref2) {
    var children = _ref2.children;
    var kids = React__default.Children.toArray(children);
    return twoColumns && srcset ? /*#__PURE__*/React__default.createElement("div", {
      className: cnRow
    }, /*#__PURE__*/React__default.createElement("div", {
      className: cnCol
    }, kids[0]), /*#__PURE__*/React__default.createElement("div", {
      className: cnCol
    }, kids[1])) : children;
  };

  Wrapper.propTypes = {
    children: PropTypes.node
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, /*#__PURE__*/React__default.createElement(Wrapper, null, srcset && /*#__PURE__*/React__default.createElement(Img, {
    className: cnImage,
    srcset: srcset,
    alt: alt || headline
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cnContent
  }, /*#__PURE__*/React__default.createElement("h1", null, headline), /*#__PURE__*/React__default.createElement("p", null, body), /*#__PURE__*/React__default.createElement("div", {
    className: cnFooter
  }, date && /*#__PURE__*/React__default.createElement("time", {
    className: cnDate
  }, date), readingTime && /*#__PURE__*/React__default.createElement("div", {
    className: cnReadingTime
  }, /*#__PURE__*/React__default.createElement(Icon, {
    id: "time",
    size: "xxs",
    className: cnIcon
  }), readingTime, " ", timeUnit)))));
}
Stage.propTypes = {
  /** Alt text */
  alt: PropTypes.string,

  /** Paragraph text */
  body: PropTypes.string.isRequired,

  /** Additional class name */
  className: PropTypes.string,

  /** Date to display */
  date: PropTypes.any,

  /** Title text */
  headline: PropTypes.string.isRequired,

  /** Minutes to be displayed */
  readingTime: PropTypes.number,

  /** Header image(s) */
  srcset: Img.propTypes.srcset,

  /** Unit for reading time */
  timeUnit: PropTypes.string,

  /** True for two column styling */
  twoColumns: PropTypes.bool
};
Stage.defaultProps = {
  timeUnit: 'min'
};

module.exports = Stage;
